module.exports = __webpack_public_path__ + "static/media/menu.78501a42.svg";